<template>
    <div class="bg-dark" style="width: 100%;height:100%;opacity: 0;transition: opacity 1s">
        <div v-if="small">
            <div style="padding:6px">
                <cover-card :image="coverImage" :quote="d.quote" :text="d.brief" style="margin:auto;margin-top:6px"></cover-card>
                <div style="box-sizing: border-box; margin:auto;margin-top:6px;width:100%;max-width: 600px"
                     v-for="(people,index) in team">
                    <arrow-card style="width:100%;max-width: 600px;margin-bottom:5px"
                                :direction="index%2===0?'right':'left'" :name="people.name" :title="people.title"
                                :subtitle="people.subtitle" :details="people.details"
                                :thumb="baseURL+'about/'+people.thumb"
                                :photo="baseURL+'about/'+people.photo"></arrow-card>
                </div>
            </div>

        </div>
        <div v-if="!small">
            <table  class="main-display-width" cellpadding="0" cellspacing="6">
                <tr>
                    <td valign="top" width="50%">
                        <cover-card :image="coverImage" :quote="d.quote" :text="d.brief" style="margin-top:6px"></cover-card>
<!--                        <div ref="brief" class="content-font bg-darker bg-cover"-->
<!--                             style="width:100%;max-width: 600px;margin-top:6px;padding-top: 50%;box-sizing: border-box;border:0px;position: relative;">-->
<!--                            <div class="flex-center text-center"-->
<!--                                 style="position:absolute;width:100%;height:100%;top:0px;padding:50px;box-sizing: border-box;background-color: rgba(0, 0, 0, 0.3);">-->

<!--                                <div class="font-slogan" v-if="d.quote!==null">{{d.quote}}</div>-->
<!--                                <br/>-->
<!--                                {{d.brief}}-->
<!--                            </div>-->
<!--                        </div>-->
                        <div v-for="(people,index) in odd">
                            <arrow-card style="width:100%;max-width: 600px;margin-top:6px;"
                                        :direction="index%2===0?'right':'left'" :name="people.name"
                                        :title="people.title" :subtitle="people.subtitle" :details="people.details"
                                        :thumb="baseURL+'about/'+people.thumb"
                                        :photo="baseURL+'about/'+people.photo"></arrow-card>
                        </div>
                    </td>
                    <td valign="top" width="50%">
                        <div v-for="(people,index) in even">
                            <arrow-card style="width:100%;max-width: 600px;margin-top:6px;"
                                        :direction="index%2!==0?'right':'left'" :name="people.name"
                                        :title="people.title" :subtitle="people.subtitle" :details="people.details"
                                        :thumb="baseURL+'about/'+people.thumb"
                                        :photo="baseURL+'about/'+people.photo"></arrow-card>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <contact-card style="padding:6px;padding-top: 0px"></contact-card>
        <foot></foot>
    </div>
</template>

<script>
	import ArrowCard from "@/components/ArrowCard";
	import axios from 'axios';

	import Foot from "@/components/Foot";
	import ContactCard from "@/components/ContactCard";
	import CoverCard from "@/components/CoverCard";

	export default {
		name: "team",
		props: {
			baseURL: String
		},
		data() {
			return {
				d: {},
                team:null,
				odd: [],
				even: [],
                coverImage:null
			}
		},
		components: {
			Foot,
			ArrowCard,
			ContactCard,
            CoverCard
		},
		methods: {},
		computed: {
			small() {
				return this.$mq === 'sm';
			}
		},
		mounted() {
			// console.log(this.baseURL+'/about/' + 'conf.json');
			setTimeout(() => {
				this.$el.style.opacity = '1'
			}, 10);
			axios
				.get(this.baseURL + 'about/' + 'conf.json',{
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json"
					},
					method: "POST",
					mode: "cors"
                })
				.then(response => {
					this.d = response.data;
					this.coverImage=this.baseURL+"about/"+this.d.cover;
					this.team=response.data.team;
					for (let i = 0; i < this.team.length; i++) {
						if (i % 2 === 0) {
							this.even.push(this.team[i]);
						} else {
							this.odd.push(this.team[i]);
						}
					}
				});
		}
	}
</script>

<style scoped>

</style>